export function setFavicon(href: string): void {
  const link =
    document.querySelector<HTMLLinkElement>("link[rel*='icon']") ??
    document.createElement('link');

  link.rel = 'icon';
  link.type = href.endsWith('.svg') ? 'image/svg+xml' : 'image/x-icon';
  link.href = href;

  if (!link.parentElement) {
    document.head.appendChild(link);
  }
}
